import { Button, Input, Spin } from "antd";
import React from "react";
import '../styles/FormInput.css';

const FormInput = (props) => {
    const handleChange = (e) => {
        const input = e.target.value;
        if (props.noNumbers) {
            if (/^[a-zA-Z]*$/.test(input)) {
                props.onchange(input);
            }
        } else {
            props.onchange(input);
        }
    };
    return (
        <div className="form-input-container" style={{...props.style}}>
            <div className="form-label">
                {props.label}{props.mandatory ? <span className="mandatory">*</span> : <></>}
            </div>
            <div className={props.buttonLabel ? "input-field-container margin-r-10" : "input-field-container"}>
                <Input type={props.type ? props.type : 'text'} inputMode={props.inputMode} maxLength={props.maxLength || ''} pattern={props.pattern ? props.pattern : ''} placeholder={props.placeholder ? props.placeholder : ''} value={props.value} onChange={(e) => { handleChange(e);  }} disabled={props.disabled ? props.disabled : false} />
                {props.buttonLabel ? <Button style={{backgroundColor:'#5f0a10',color:'white'}} onClick={props.onButtonClick}>{props.isButtonLoading ? <Spin/> : props.buttonLabel}</Button> : <></>}
            </div>
        </div>
    )
}
export default FormInput;